<template>
  <li class="divider"></li>
</template>
<script>
  export default {
    name: 'NavbarNavDropdownDivider'
  }
</script>



// WEBPACK FOOTER //
// navbar-nav-dropdown-divider.vue?49d1bf2e